import { millisecondsToSeconds } from 'date-fns';

import { setTimer } from './actions';
import { SET_TIMER } from './constants';
import { TimerState } from './reducer.types';

const timerInitialState: TimerState = {
    currentTime: millisecondsToSeconds(Date.now()),
};

const handlers = {
    [SET_TIMER](
        state: TimerState,
        { payload: { time } }: ReturnType<typeof setTimer>,
    ): TimerState {
        return {
            ...state,
            currentTime: time,
        };
    },
};

export default { initialState: timerInitialState, handlers };
